import { Box, Button, Card, CardActions, CardContent, colors, Grid, Paper, Skeleton, Typography, useTheme } from '@mui/material';
import { BikeleasingDealerListDTO } from 'probonio-shared-ui/api';
import { useTenantQuery } from 'probonio-shared-ui/module/api';
import { apis } from 'probonio-shared-ui/module/api/APILoader';
import { useTranslation } from 'react-i18next';

export const BikeleasingVendorOnline: React.FC = () => {
  const { t } = useTranslation('benefitModule');
  const theme = useTheme();

  const { data: bikeleasingDealers, isLoading } = useTenantQuery<BikeleasingDealerListDTO>(
    ['bikeleasing', 'benefit', 'dealers'],
    tenantId => apis.bikeLeasingV2.listBikeleasingDealers({ tenantId }).then(res => res.data),
  );

  return (
    <Box paddingBottom={2}>
      <Box>
        <Card
          sx={{
            backgroundImage: 'url(image/bikeleasing-vendor.png)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            height: '400px',
            borderRadius: 0,
          }}
        >
          <Box sx={{ backdropFilter: 'brightness(0.5)' }} height={'100%'} padding={1}>
            <CardContent>
              <Typography gutterBottom variant="h1" sx={{ color: 'common.white' }}>
                {t('extensions:bikeleasing_v2_benefit.vendorOnline.hero.title')}
              </Typography>
              <Typography variant="caption" whiteSpace={'pre-line'} display={'block'} width={'80%'} sx={{ color: 'common.white' }}>
                {t('extensions:bikeleasing_v2_benefit.vendorOnline.hero.subtitle')}
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                sx={{ bgcolor: colors.grey[900], color: 'common.white' }}
                href={`${import.meta.env.VITE_BIKELEASING_WEBSITE_URL}/haendler-finden/onlinehandel`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('extensions:bikeleasing_v2_benefit.vendorOnline.hero.btnText')}
              </Button>
            </CardActions>
          </Box>
        </Card>
      </Box>
      <Box paddingX={1} paddingTop={1}>
        <Typography gutterBottom variant="h1">
          {t('extensions:bikeleasing_v2_benefit.vendorOnline.title')}
        </Typography>
        <Typography gutterBottom variant="subtitle2">
          {t('extensions:bikeleasing_v2_benefit.vendorOnline.subtitle')}
        </Typography>
        <Grid container spacing={0.5} marginTop={0.5}>
          {isLoading ? (
            <>
              {[...Array(4)].map((_, index) => (
                <Grid size={3} key={index}>
                  <Paper
                    variant="outlined"
                    sx={{
                      aspectRatio: '1/1',
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: 2,
                      bgcolor: colors.grey[200],
                    }}
                  >
                    <Skeleton variant="rounded" width="100%" height="100%" sx={{ borderRadius: 2 }} />
                  </Paper>
                </Grid>
              ))}
            </>
          ) : (
            bikeleasingDealers?.results.map(dealer => (
              <Grid size={3} key={dealer.id}>
                <Paper
                  variant="outlined"
                  sx={{
                    backgroundColor: theme.palette.common.white,
                    aspectRatio: '1/1',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2,
                    p: 0.25,
                  }}
                >
                  <a href={dealer.link.url} target={dealer.link.target} rel="noreferrer" style={{ color: theme.palette.primary.main }}>
                    <img src={dealer.image.url} alt={dealer.image.alternative} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                  </a>
                </Paper>
              </Grid>
            ))
          )}
          {!isLoading && !bikeleasingDealers?.totalCount && (
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  padding: 1,
                  borderRadius: 2,
                }}
              >
                <Typography>{t('extensions:bikeleasing_v2.dealers.noData')}</Typography>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
};
